import { render, staticRenderFns } from "./GroupManager.vue?vue&type=template&id=21526aa3"
import script from "./GroupManager.vue?vue&type=script&lang=ts"
export * from "./GroupManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports